import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AsyncPipe, NgIf } from '@angular/common';
import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  inject,
  Input,
} from '@angular/core';
import type { ButtonColor, SizeType } from '@cf/core';
import { LoadingService } from '@cf/core';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-button, a[cf-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, AsyncPipe, NgxTolgeeModule],
})
export class ButtonComponent implements OnInit {
  public readonly loadingService = inject(LoadingService);
  private element = inject<ElementRef<HTMLButtonElement>>(ElementRef);

  @HostBinding('attr.type') @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @HostBinding('class.disabled') @Input() disabled = false;

  @Input() className: string | null = null;

  @Input() color: ButtonColor = 'primary';

  @Input() size: SizeType = 'md';

  @Input() btnStyle: 'std' | 'ghost' | 'icon' = 'std';

  @Input() loadingState!: boolean;

  thisTargetClicked = false;

  private _isLoadingBtn = false;

  private _disableOnRequest = false;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Input()
  get disableOnRequest() {
    return this._disableOnRequest;
  }

  set disableOnRequest(value: any) {
    this._disableOnRequest = coerceBooleanProperty(value);
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Input()
  get isLoadingBtn() {
    return this._isLoadingBtn;
  }

  set isLoadingBtn(value: any) {
    this._isLoadingBtn = coerceBooleanProperty(value);
  }

  @HostListener('click') clicked(): void {
    this.thisTargetClicked = true;
    setTimeout(() => (this.thisTargetClicked = false), 0);
  }

  ngOnInit() {
    this.loadingService.loadingState$.subscribe((isLoading: boolean) => {
      if (this.disableOnRequest) {
        this.element.nativeElement.style.pointerEvents = isLoading ? 'none' : 'auto';
      }
    });
  }
}
